import { IImportUserDetailsFailedUserInterface } from 'app/projects/user/src/lib/interfaces/import-user-details-failed-user.interface';
import { IImportUserDetailsModulesInterface } from 'app/projects/user/src/lib/interfaces/import-user-details-modules.interface';
import { User } from 'app/projects/user/src/lib/models/user';
import { IModuleAssignmentQuery } from '../interfaces/module-assignment.query';
import { IImportUserFailedQuery, IUserImportReportQuery } from '../interfaces/user-import-report.query.interface';

export class UsersImportReport {
    private _users: User[];
    private _usersCreated: number[];
    private _usersDuplicated: number[];
    private _usersFailed: IImportUserDetailsFailedUserInterface[];
    private _modules: IImportUserDetailsModulesInterface[];

    constructor(query?: IUserImportReportQuery) {
        if (query) {
            this._users = query.users.map((createdQuery) => new User(createdQuery));
            this._usersCreated = [...query.import.created];
            this._usersDuplicated = [...query.import.duplicates];
            this._usersFailed = (query.import.failed || []).map((failedUser) => this.transformToFailedUser(failedUser));
            this._modules = query.module_assignment.map((module) => this.transformToImportUserDetailsModules(module));
        }
    }

    protected reducerUser(reducer: string[], user: User): string[] {
        reducer.push(`${user.email}`);
        return reducer;
    }

    protected transformToImportUserDetailsModules(moduleAssignmentQuery: IModuleAssignmentQuery): IImportUserDetailsModulesInterface {
        return {
            moduleName: moduleAssignmentQuery.module_name,
            newlyAssigned: moduleAssignmentQuery.newly_assigned.length,
            assignmentFailed: moduleAssignmentQuery.assignment_failed.length,
            alreadyAssigned: moduleAssignmentQuery.already_assigned.length,
            users: this._users.reduce(this.reducerUser, []).join(', '),
            error: moduleAssignmentQuery.error ? moduleAssignmentQuery.error.message : '',
        };
    }

    protected transformToFailedUser(failedUserQuery: IImportUserFailedQuery): IImportUserDetailsFailedUserInterface {
        return {
            email: failedUserQuery.email,
            firstName: failedUserQuery.first_name,
            lastName: failedUserQuery.last_name,
            language: failedUserQuery.language,
            error: failedUserQuery.error,
        };
    }

    /** Users **/
    public getUsersCreated(): User[] {
        return this._users.filter((user) => this._usersCreated.includes(+user.id));
    }
    public getUsersDuplicated(): User[] {
        return this._users.filter((user) => this._usersDuplicated.includes(+user.id));
    }
    public getUsersFailed(): IImportUserDetailsFailedUserInterface[] {
        return [...this._usersFailed];
    }
    /** Modules **/
    public getModules(): IImportUserDetailsModulesInterface[] {
        return [...this._modules];
    }
}
